const permissions = {
  PAW_ADMIN: 'isPawAdmin',
  CHARITY_ADMIN: 'isCharityAdmin',
  CHARITY_USER: 'isCharityUser',
  FOSTERER: 'isFosterer',
};

export default permissions;
